export default __webpack_public_path__ + "static/media/btn-futuristic-secondary-side-right.2b24d661.png";